module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/handshake-dc29b68c7295e3735b8f9f1743480e04.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/handshake.svg
// module id = se+F
// module chunks = 24